import { ItemsListContainerBase } from '../../../components/items-list-container-base';
import {
    Component,
    OnInit,
    Input,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Injector,
    Output,
    EventEmitter,
} from '@angular/core';
import { FormReportActivityListData } from './fi-form-report-activity-list-data';
import { IFormReportSubmission, IFormReportView } from '../fi-form-report';
import { FormReportNavigation } from '../fi-form-report-navigation';
import { FiStateService } from '../../../shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '../../../shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-report-activity',
    template: `
        @if (!isUserDetails && !isCompleteReport) {
          <mat-card class="fi-form-report-card">
            <mat-card-title class="BrandedBackgroundColor mat-card-title-text-center-container">
              <!--<div class="fi-form-report-back-button-wrapper">
              <mat-icon (click)="goBack()" class="fi-form-report-back-icon cursor-pointer">
                <span class="fa fa-chevron-left"></span>
              </mat-icon>
              <span (click)="goBack()" class="cursor-pointer">{{"back" | fiAppText}}</span>
            </div>-->
            <span class="fi-form-report-title-text">{{ 'form.submissions_all' | fiAppText }}</span>
            <div class="fi-form-report-additional-item"></div>
          </mat-card-title>
          <mat-card-content>
            <p class="fi-form-report-description-paragraph">{{ 'form.submissions_description' | fiAppText }}</p>
            <div class="fi-form-report-item-list-wrapper">
              <fi-items-list [settings]="ListData" [module]="[FiStateNames.Form._name]"></fi-items-list>
            </div>
          </mat-card-content>
        </mat-card>
        }
        
        @if (isUserDetails && !isCompleteReport) {
          <fi-form-report-activity-user-report
            [submissionId]="selectedSubmission.Id"
            [answerSetId]="selectedSubmission.AnswerSets[selectedSubmissionIndex].Id"
            [formReport]="formReport"
            (back)="onUserReportBackClick()"
            >
          </fi-form-report-activity-user-report>
        }
        
        @if (isCompleteReport) {
          <div>
            @for (submission of submissions; track submission) {
              <div>
                @for (answerSet of submission.AnswerSets; track answerSet; let i = $index) {
                  <fi-form-report-activity-user-report
                    [submissionId]="submission.Id"
                    [answerSetId]="answerSet.Id"
                    [formReport]="formReport"
                    [isCompleteReport]="true"
                    (back)="onUserReportBackClick()"
                    >
                  </fi-form-report-activity-user-report>
                }
              </div>
            }
          </div>
        }
        `,
    styleUrls: ['./fi-form-report-activity-list.component.scss', '../fi-form-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiFormReportActivityComponent
    extends ItemsListContainerBase<FormReportActivityListData>
    implements OnInit
{
    @Input() submissions: IFormReportSubmission[];
    @Input() formReport: IFormReportView;
    @Input() isCompleteReport: boolean = false;
    @Output() back = new EventEmitter();

    isUserDetails: boolean = false;
    selectedSubmission: IFormReportSubmission;
    selectedSubmissionIndex: number = 0;
    FiStateNames = FiStateNames;

    constructor(
        private injector: Injector,
        private stateService: FiStateService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () =>
                new FormReportActivityListData(this.injector, (data: IFormReportSubmission, parentData) => {
                    this.goToUserReport(data, parentData);
                }),
            {
                noLocalSearch: true,
                showDelete: false,
            },
        );
    }

    goToUserReport(data: IFormReportSubmission, parentData?) {
        this.selectedSubmission = data;
        this.selectedSubmissionIndex = 0;
        if (parentData) {
            this.selectedSubmission = parentData;
            this.selectedSubmissionIndex = parentData.AnswerSets.indexOf(data);
        }
        this.stateService.go(FiStateNames.Form.Report.View, {
            id: this.formReport.Id,
            pos: FormReportNavigation.UserDetails,
        });

        this.isUserDetails = true;
        this.stateService.setBackButtonHandler(() => {
            this.isUserDetails = false;
            this.goBack();
        });
    }

    onUserReportBackClick() {
        this.isUserDetails = false;
    }

    goBack() {
        this.back.emit();
    }

    protected LoadItems() {
        this.ListData.Data = this.submissions;
        return Promise.resolve();
    }

    protected SetItemsCount() {
        return Promise.resolve(this.submissions.length);
    }
}
